import { useEffect } from "react";
import useWindowSize from "../../../../hooks/useWindowSize";
import { func } from "../../../../utils";
import {
  Button,
  Card,
  Container,
  HighlightedDate,
  Icon,
  InnerCardContainer,
  Stroke,
  SubtitleCard,
  TitleCard,
} from "./TimelinePathPopUp.styled";
import moment from "moment";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/timeline/`;

const CirclePath = ({ isActive, isHalf, isDone }) => {
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 768;
  if (isDone) {
    return (
      <img
        src={func.getStaticImg(`illustration/point-timeline.svg`)}
        style={{
          marginTop: isHalf ? 44 : 0,
          width: 16,
        }}
      />
    );
  }
  if (isActive) {
    return (
      <img
        src={func.getStaticImg(`illustration/active-circle-timeline.svg`)}
        style={{
          marginTop: isHalf ? 44 : 0,
          width: 16,
        }}
      />
    );
  } else {
    return (
      <img
        src={func.getStaticImg(`illustration/inactive-circle-timeline.svg`)}
        style={{
          marginTop: isHalf ? 44 : 0,
          width: 16,
        }}
      />
    );
  }
};

const TimelinePathPopUp = ({ data = [] }) => {
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 768;

  //get item status === 1 or last item
  const activeItem = data?.find((item) => item.status === 1)
    ? data.find((item) => item.status === 1)
    : data?.[data?.length - 1];
  const indexActiveItem = data?.findIndex((item) => item.status === 1);

  const dataFinal = data?.map((val, i) => {
    return {
      ...val,
      isDone: i < indexActiveItem,
      isActive: i <= indexActiveItem,
    };
  });

  const lastDate = data?.[data?.length - 1]?.end_date;
  const isSeriesDone = moment().isAfter(lastDate) || indexActiveItem === -1;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
        maxWidth: isMobileView ? "100%" : "fit-content",
      }}
    >
      <Container id="container-timeline-path">
        {dataFinal?.map((val, i) => {
          const getDate = (index) => {
            const startShortDate = moment(val?.start_date)?.format("D MMMM");
            const shortDate = moment(val?.start_date)?.format("D MMMM YYYY");

            const endFullDate = moment(val?.end_date)?.format("D MMMM YYYY");

            if (val?.start_date !== val?.end_date) {
              //check if month is the same
              if (moment(val?.start_date)?.isSame(val?.end_date, "month")) {
                return `${moment(val?.start_date)?.format(
                  "D"
                )} - ${endFullDate}`;
              }
              return `${startShortDate} - ${endFullDate}`;
            } else {
              console.log("kalo sama", val?.start_date, val?.end_date);
              return shortDate;
            }
          };

          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              {isSeriesDone ? (
                <>
                  <div
                    style={{
                      flexDirection: "column",
                      alignItems: "center",
                      display: "flex",
                      height: 96,
                    }}
                  >
                    {!i ? (
                      <>
                        <CirclePath isActive={false} isHalf isDone={true} />
                        <Stroke height={"50%"} isActive={true} />
                      </>
                    ) : (
                      <>
                        <Stroke height={"50%"} isActive={true} />
                        <CirclePath isActive={false} isDone={true} />
                        {dataFinal?.length - 1 !== i && (
                          <Stroke height={"50%"} isActive={true} />
                        )}
                      </>
                    )}
                  </div>
                  <Card isActive={false} isDone={true} marginLeft={"8px"}>
                    <Icon
                      src={imgPath + val?.icon}
                      isActive={false}
                      isDone={true}
                    />
                    <InnerCardContainer>
                      <TitleCard isActive={false} isDone={true}>
                        {val?.title}
                      </TitleCard>
                      <HighlightedDate isHalf isActive={false}>
                        {getDate(i)}
                      </HighlightedDate>
                      <SubtitleCard>{val?.subtitle}</SubtitleCard>
                    </InnerCardContainer>

                    <Icon
                      style={{ marginLeft: "auto" }}
                      src={func.getStaticImg(`illustration/checklist.svg`)}
                      isActive={true}
                    />
                  </Card>
                </>
              ) : (
                <>
                  <div
                    style={{
                      flexDirection: "column",
                      alignItems: "center",
                      display: "flex",
                      height: 96,
                    }}
                  >
                    {!i ? (
                      <>
                        <CirclePath
                          isActive={val?.isActive}
                          isHalf
                          isDone={val?.isDone}
                        />
                        <Stroke height={"50%"} isActive={val?.isDone} />
                      </>
                    ) : (
                      <>
                        <Stroke height={"50%"} isActive={val?.isActive} />
                        <CirclePath
                          isActive={val?.isActive}
                          isDone={val?.isDone}
                        />
                        {dataFinal?.length - 1 !== i && (
                          <Stroke height={"50%"} isActive={val?.isDone} />
                        )}
                      </>
                    )}
                  </div>
                  <Card
                    isActive={val?.status === 1}
                    isDone={val?.isDone}
                    marginLeft={"8px"}
                    onClick={() => {
                      if (val?.status === 1) {
                        window.open(val?.link, "_blank");
                      }
                    }}
                  >
                    <Icon src={imgPath + val?.icon} isActive={val?.isActive} />
                    <InnerCardContainer>
                      <TitleCard isActive={val?.isActive} isDone={val?.isDone}>
                        {val?.title}
                      </TitleCard>
                      <HighlightedDate isHalf isActive={val?.status === 1}>
                        {getDate(i)}
                      </HighlightedDate>
                      <SubtitleCard>{val?.subtitle}</SubtitleCard>
                    </InnerCardContainer>

                    <Icon
                      style={{ marginLeft: "auto" }}
                      src={func.getStaticImg(
                        `illustration/${
                          val?.isDone ? "checklist" : "sa-chevron-right-blue"
                        }.svg`
                      )}
                      isActive={val?.isActive}
                    />
                  </Card>
                </>
              )}
            </div>
          );
        })}
      </Container>
      <Button
        onClick={() => {
          if (!!activeItem?.link) {
            window.open(activeItem?.link, "_blank");
          }
        }}
      >
        {isSeriesDone ? "Lihat Statistik" : activeItem?.button_text}
      </Button>
    </div>
  );
};

export default TimelinePathPopUp;
